import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import { VOID_FUNCTION } from 'constants/index';
import { DropDown } from 'components/uikit/DropDown/DropDown';
import { ChevronUpMIcon, ChevronDownMIcon, CheckSIcon } from 'assets/icons';
import * as S from './Select.styles';
import { useSelectPresenter } from './Select.presenter';

export const Select = ({
  className,
  value,
  list = [],
  name,
  search = false,
  searchTitle = '',
  onSearch,
  placeholder,
  theme = 1,
  error,
  description,
  disabled,
  dataTest = '',
  dropDownPosition = 'bottom',
  control = null,
  onClick = VOID_FUNCTION,
  onChange = VOID_FUNCTION,
  onBlur = VOID_FUNCTION,
  onFocus = VOID_FUNCTION,
}) => {
  const presenter = useSelectPresenter({
    name,
    value,
    list,
    disabled,
    onClick,
    onChange,
    onBlur,
    onSearch,
  });

  return (
    <S.Container
      ref={presenter.selectorRef}
      className={className}
      dataTest={dataTest}
      disabled={disabled}
      theme={theme}
    >
      <OutsideClickHandler onOutsideClick={presenter.outsideClickHandler}>
        <S.SelectComponent
          onChange={presenter.selectorChangeHandler}
          onClick={presenter.selectorClickHandler}
          onMouseDown={presenter.selectorMouseDownHandler}
          isOpened={presenter.isDropDownShown}
          isSelected={!!presenter.selectedItem}
          name={name || ''}
          onFocus={onFocus}
          disabled={disabled}
          error={error}
          withControl={Boolean(control)}
        >
          {placeholder && !presenter.selectedItem && <S.OptionItem>{placeholder}</S.OptionItem>}
          {list.map((i) => (
            <S.OptionItem
              key={i.id}
              selected={presenter.selectedItem?.id === i.id}
              visible={presenter.selectedItem?.id === i.id}
            >
              {i.title}
            </S.OptionItem>
          ))}
        </S.SelectComponent>

        {presenter.selectedItem && <S.Placeholder>{placeholder}</S.Placeholder>}

        {control && (
          <S.ControlWrapper onClick={presenter.selectorClickHandler}>{control}</S.ControlWrapper>
        )}

        <S.Chevron
          Icon={presenter.isDropDownShown ? ChevronUpMIcon : ChevronDownMIcon}
          onClick={presenter.selectorClickHandler}
          theme="3"
        />

        {error && <S.Error>{error}</S.Error>}

        {!error && description && <S.Description>{description}</S.Description>}

        {presenter.isDropDownShown && (
          <DropDown
            ref={presenter.dropDownRef}
            targetRef={presenter.selectorRef}
            gap={10}
            position={dropDownPosition}
          >
            <S.DropDownContainer theme={theme}>
              <>
                {search && (
                  <S.SearchInput
                    value={presenter.searchStr}
                    label={searchTitle || 'Найти'}
                    onChange={presenter.searchStrChangeHandler}
                  />
                )}
                {presenter.filteredList.map((item) => (
                  <S.ListItemStyled
                    size="m"
                    gap={8}
                    key={item.id}
                    title={item.title}
                    description={item.description}
                    subTitle={item.subTitle}
                    onClick={() => presenter.itemClickHandler(item)}
                    selected={value === item?.id}
                    leftSlot={
                      value === item?.id ? <S.CheckIcon Icon={CheckSIcon} /> : <S.EmptyIcon />
                    }
                  />
                ))}
              </>
            </S.DropDownContainer>
          </DropDown>
        )}
      </OutsideClickHandler>
    </S.Container>
  );
};
